import { validateEmail } from "./validate-email";
import { postLog } from "./log";

/**
 * Query the API for an existing membership with the given email.
 * 
 * @param string email Email address to check. 
 * @param object config Configuration options.
 * @param string authenticationToken Request authentication token.
 * 
 * @return Promise<null|object> Null on missing or invalid data, or object with the following properties:
 * - exists: boolean - Whether or not a membership with the given email was found.
 * - canRenew: boolean - Whether or not the found membership is eligible for renewal.
 */
export default async function checkMemberEmail(email, config, authenticationToken) {
    email = email?.trim();

    if(!email) {
        return null;
    }

    if(!config?.apiUrl) {
        return null;
    }

    if(!authenticationToken) {
        return null;
    }

    if(!validateEmail(email)) {
        return null;
    }

    try {
        const params = new URLSearchParams();

        params.append("email", email);

        const response = await fetch(`https://${config.apiUrl}/api/membership/exists?${params}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Authorization": authenticationToken
            },
        });

        if (!response.ok) {
            postLog(config, authenticationToken, response.url, String(response.status));

            throw new Error(response.url + ' ' + response.statusText);
        }

        const data = await response.json();
        
        console.log(data);
        
        return data;
    } catch (error) {
        console.error(error);

        return null;
    }
}